"use client";

import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap justify-center gap-6">
        <div className="h-4 w-16 bg-muted-foreground/20 animate-pulse rounded" />
        <div className="h-4 w-20 bg-muted-foreground/20 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted-foreground/20 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-wrap gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm font-medium text-foreground-dark hover:text-foreground-dark/90 relative inline-block after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-foreground-dark after:transition-all after:duration-300 hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }];
  return <footer className="w-full bg-dark-background text-foreground-dark py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center gap-8">
          {}
          <MenuProvider menu_id="46">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          

          {}
          <p className="text-sm text-foreground-dark/70 text-center">© 2022 RESTORE AND HOPE LLC. All rights reserved.{new Date().getFullYear()}</p>
        </div>
      </div>
    </footer>;
}